module.exports = __webpack_public_path__ + "media/crypto/pax-52ec4adb.png";